import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const AssessmentEfficiency = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Button
          variant="ghost"
          className="mb-8"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>
        
        <h1 className="text-4xl font-bold mb-6">Assessment Efficiency Impact</h1>
        <p className="text-lg text-gray-600 mb-8">
          Our AI-powered assessment tools have demonstrated a 40-50% reduction in cognitive assessment time while maintaining clinical accuracy. This improvement is based on comprehensive studies in healthcare settings and real-world implementations.
        </p>
        
        <div className="space-y-6">
          <h2 className="text-2xl font-semibold">Key Benefits</h2>
          <ul className="list-disc list-inside space-y-4 text-gray-600">
            <li>Reduced assessment duration without compromising accuracy</li>
            <li>Increased patient throughput and satisfaction</li>
            <li>More time for meaningful patient-provider interactions</li>
            <li>Standardized assessment procedures</li>
            <li>Real-time data analysis and insights</li>
          </ul>
        </div>
      </main>
    </div>
  );
};

export default AssessmentEfficiency;